function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { DatePicker, Popover, TextInput } from '../..';
import { Container, DatePickerWrapper, PopoverContainer } from './elements';
/**
 * The DatePickerInput component is an input that toggles a popover with a date picker
 *
 * See README.md and stories from Storybook for more documentation
 *
 * @returns {jsx}
 */

var DatePickerInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(DatePickerInput, _PureComponent);

  var _super = _createSuper(DatePickerInput);

  function DatePickerInput() {
    var _this;

    _classCallCheck(this, DatePickerInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "ref", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDatePickerOpen: false,
      // whether the date picker is displayed or not
      dateValue: null,
      // value passed down to the date picker
      textValue: null,
      // value displayed in the input text
      error: false // whether input text should be displayed with an error state

    });

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function () {
      _this.setState({
        isDatePickerOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateChange", function (dateValue) {
      var onChange = _this.props.onChange;
      onChange(dateValue);

      _this.setState({
        dateValue: dateValue,
        textValue: dateValue,
        isDatePickerOpen: false,
        error: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (textValue) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          onChange = _this$props.onChange;

      _this.setState({
        textValue: textValue
      });

      var _textValue$split$map = textValue.split('/').map(function (v) {
        return Number(v, 10);
      }),
          _textValue$split$map2 = _slicedToArray(_textValue$split$map, 3),
          day = _textValue$split$map2[0],
          month = _textValue$split$map2[1],
          year = _textValue$split$map2[2];

      var newValue = DateTime.fromObject({
        year: year,
        month: month,
        day: day
      });
      onChange(newValue);

      if (day && month && year && newValue.isValid && (!maxDate || newValue <= maxDate) && (!minDate || newValue >= minDate)) {
        _this.setState({
          dateValue: newValue,
          error: false
        });
      } else {
        _this.setState({
          dateValue: DateTime.local(),
          error: true
        });
      }
    });

    return _this;
  }

  _createClass(DatePickerInput, [{
    key: "componentDidMount",
    value:
    /**
     * Component lifecycle method
     * Sets initial values if provided by the parent otherwise take today
     *
     */
    function componentDidMount() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          error = _this$props2.error;
      this.setState({
        dateValue: value || DateTime.local(),
        textValue: value || DateTime.local(),
        error: error
      });
    }
    /**
     * Component lifecycle method
     * Handles error value according to what the parent component passes down
     * only if the update comes from prop change and not state change
     * since state change comes from inner state update in handleInputChange and handleDateChange
     *
     * @param {Object} prevProps - The component's previous props.
     * @param {Object} prevState - The component's previous state.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var currentErrorProp = this.props.error;
      var error = this.state.error;

      if (prevState.error === error && prevProps.error !== currentErrorProp) {
        this.setState({
          error: currentErrorProp
        });
      }
    }
    /**
     * Toggles visibility of the date picker
     * Closes the date picker if the user has clicked outside this component
     *
     */

  }, {
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @returns {jsx}
     */
    function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          fluid = _this$props3.fluid,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate;
      var _this$state = this.state,
          isDatePickerOpen = _this$state.isDatePickerOpen,
          error = _this$state.error,
          textValue = _this$state.textValue,
          dateValue = _this$state.dateValue;
      return /*#__PURE__*/React.createElement(Container, {
        ref: function ref(node) {
          return _this2.ref = node;
        }
      }, /*#__PURE__*/React.createElement(PopoverContainer, null, /*#__PURE__*/React.createElement(Popover, {
        isOpen: isDatePickerOpen,
        content: /*#__PURE__*/React.createElement(DatePickerWrapper, null, /*#__PURE__*/React.createElement(DatePicker, {
          minDate: minDate,
          maxDate: maxDate,
          defaultValue: dateValue,
          value: dateValue,
          onDateChanged: this.handleDateChange
        })),
        onClickOutside: this.handleOutsideClick,
        placement: "bottom-start"
      }, /*#__PURE__*/React.createElement(TextInput, {
        fluid: fluid,
        value: textValue ? textValue.toLocaleString(DateTime.DATE_SHORT) : '',
        type: "text",
        onFocus: function onFocus() {
          return _this2.setState({
            isDatePickerOpen: true
          });
        },
        onChange: this.handleInputChange,
        error: error
      }))));
    }
  }]);

  return DatePickerInput;
}(PureComponent);

var bool = PropTypes.bool,
    func = PropTypes.func,
    object = PropTypes.object;
/** Prop types validation. */

DatePickerInput.propTypes = {
  /**
   * Whether the input has a status error
   */
  error: bool,

  /**
   * Whether the input takes all available space or not
   */
  fluid: bool,

  /**
   * The maximum selectable date
   */
  maxDate: object,

  /**
   * The minimum selectable date
   */
  minDate: object,

  /**
   * Handler on date changed
   */
  onChange: func,

  /**
   * The current value of the selected date (controlled mode)
   */
  value: object
};
/** Default props. */

DatePickerInput.defaultProps = {
  error: false,
  fluid: false,
  maxDate: null,
  minDate: null,
  onChange: function onChange() {},
  value: null
};
export default DatePickerInput;